import React, { useEffect } from 'react';
import './Disclaimer.css';
import '../PolicyPages.css';

function Disclaimer() {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div className="policy-page">

            {/* Hero */}
            <div className="policy-hero">
                <div className="container">
                    <div className="policy-hero-icon"><i className="fas fa-exclamation-circle"></i></div>
                    <h1 className="policy-hero-title">Disclaimer</h1>
                    <p className="policy-hero-sub">Last updated: June 2025</p>
                </div>
            </div>

            {/* Card */}
            <div className="container">
                <div className="policy-card">

                    <p className="policy-intro">
                        The information provided on <strong>PENTADECO.IN</strong> is for general informational purposes only.
                        While we make every effort to ensure that the information on this website is accurate and up to date,
                        we make no representations or warranties of any kind, express or implied, about the completeness,
                        accuracy, reliability, suitability, or availability with respect to the website or the products,
                        services, or related graphics contained on the website for any purpose. Any reliance you place on
                        such information is strictly at your own risk.
                    </p>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">1</span>
                            <h3 className="policy-section-title">Product Representation</h3>
                        </div>
                        <p className="policy-text">
                            All product images, descriptions, and specifications are provided for illustrative purposes only.
                            Actual colors, sizes, and finishes may vary slightly due to photography lighting or device display settings.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">2</span>
                            <h3 className="policy-section-title">Limitation of Liability</h3>
                        </div>
                        <p className="policy-text">
                            Under no circumstances shall <strong>PENTADECO</strong>, its owners, employees, or affiliates be
                            held liable for any loss or damage, including without limitation indirect or consequential loss or
                            damage, arising from the use of this website or products purchased from it.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">3</span>
                            <h3 className="policy-section-title">External Links</h3>
                        </div>
                        <p className="policy-text">
                            This website may contain links to other websites that are not under the control of <strong>PENTADECO</strong>.
                            We have no control over the nature, content, and availability of those sites, and the inclusion of any
                            links does not necessarily imply a recommendation or endorsement of the views expressed within them.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">4</span>
                            <h3 className="policy-section-title">No Professional Advice</h3>
                        </div>
                        <p className="policy-text">
                            Any guidance or advice provided on this website, whether relating to product use, care, or otherwise,
                            is for informational purposes only and should not be considered as professional advice.
                            Customers are advised to use their discretion or consult a professional where necessary.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">5</span>
                            <h3 className="policy-section-title">Changes to Disclaimer</h3>
                        </div>
                        <p className="policy-text">
                            <strong>PENTADECO</strong> reserves the right to modify, update, or replace this disclaimer at any
                            time without prior notice. Customers are encouraged to review this page periodically.
                        </p>
                    </div>

                    {/* Contact */}
                    <div className="policy-contact-card">
                        <p className="policy-contact-title"><i className="fas fa-headset"></i> Contact Us</p>
                        <div className="policy-contact-row">
                            <i className="fas fa-building"></i>
                            <span>PENTADECO Customer Care</span>
                        </div>
                        <div className="policy-contact-row">
                            <i className="fas fa-envelope"></i>
                            <span><a href="mailto:pentadeco@gmail.com">pentadeco@gmail.com</a></span>
                        </div>
                        <div className="policy-contact-row">
                            <i className="fab fa-whatsapp"></i>
                            <span>
                                <a href="tel:+917738494171">+91 77384 94171</a> &nbsp;|&nbsp;
                                <a href="tel:+918433551012">+91 84335 51012</a> &nbsp;|&nbsp;
                                <a href="tel:+919273158535">+91 92731 58535</a>
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Disclaimer;
